import { CatalogEntry } from './catalog-entry';

export interface Catalog {
  catalogCode: string;
  catalogId: number;
  catalogName: string;
  entries: CatalogEntry[];
}
